
<template>
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.77776 7.64443C1.51109 7.64443 1.33336 7.55555 1.15558 7.37777C0.800027 7.02222 0.800027 6.48886 1.15558 6.13331L6.13334 1.15555C6.48889 0.799997 7.02225 0.799997 7.37781 1.15555C7.73336 1.51111 7.73336 2.04441 7.37781 2.39996L2.39999 7.37777C2.22222 7.55555 2.04443 7.64443 1.77776 7.64443Z"
            :fill="fill"
        />
        <path
            d="M6.75557 7.64443C6.48891 7.64443 6.31112 7.55555 6.13334 7.37777L1.15558 2.39996C0.800027 2.04441 0.800027 1.51111 1.15558 1.15555C1.51114 0.799997 2.04444 0.799997 2.39999 1.15555L7.37781 6.13331C7.73336 6.48886 7.73336 7.02222 7.37781 7.37777C7.20003 7.55555 7.02224 7.64443 6.75557 7.64443Z"
            :fill="fill"
        />
    </svg>
</template>
<script>
export default {
    props: {
        fill: {
            type: String,
            default: "#3965FF"
        }
    },
    name: "CloseBoldIcon"
}
</script>
